import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import truncate from 'lodash/truncate';
import { Link } from 'localmed-core';
import { intlShape } from '../../shared/shapes';

class Truncate extends Component {
  static propTypes = {
    intl: intlShape,
    text: PropTypes.string,
    length: PropTypes.number,
    separator: PropTypes.string,
    omission: PropTypes.string,
  };

  static defaultProps = {
    length: 100,
    separator: ' ',
    omission: '… More',
  };

  constructor(props, context) {
    super(props, context);
    this.state = { expanded: false };
    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    event.preventDefault();
    this.setState(prevState => ({ expanded: !prevState.expanded }));
  }

  render() {
    const { intl, text, length, separator, omission, ...props } = this.props;
    const { expanded } = this.state;
    const expandable = !expanded && text && text.length > length;
    let truncatedText = text;
    if (expandable) {
      truncatedText = truncate(text, { length, separator, omission: '' });
    }
    const omissionText =
      omission ||
      intl.formatMessage({
        id: 'widgets.Truncate.omission',
        defaultMessage: '… More',
      });
    return (
      <div aria-expanded={expandable ? 'false' : 'true'} {...props}>
        {truncatedText} {expandable && <Link onClick={this.onClick}>{omissionText}</Link>}
      </div>
    );
  }
}

export default injectIntl(Truncate);
